import {useState} from 'react';
import {Gamepad2} from 'lucide-react';
import {useLocation, useNavigate} from 'react-router-dom';
import {useCurrentWorkspaceUrlPrefix} from '@tinct/core-workspace';
import {GameModal, useJobAlert} from '@tinct/web-layout';

export function useSampleGenerationJobAlert(campaignId: string) {
  const workspaceUrl = useCurrentWorkspaceUrlPrefix();
  const navigate = useNavigate();
  const {pathname} = useLocation();
  const [gameOpen, setGameOpen] = useState(false);

  const baseUrl = `${workspaceUrl}/funnel-campaigns/${campaignId}`;

  const {start} = useJobAlert({
    name: 'Sample Generation',
    pendingUrl: pathname,
    completedUrl: `${baseUrl}/preview`,
    alert: {
      message: 'You can stay (and play?) or let it run in the background.',
      variant: 'info',
      dismissible: false,
      actions: [
        {
          label: <Gamepad2 className="size-4" />,
          onClick: () => setGameOpen(true),
          variant: 'outline',
          size: 'icon',
          dismissOnClick: false,
        },
        {
          label: 'Let it run in background',
          onClick: () => {
            navigate(`${workspaceUrl}/dashboard`, {replace: true});
          },
          variant: 'default',
        },
      ],
    },
  });

  const gameModal = <GameModal open={gameOpen} onOpenChange={setGameOpen} />;

  return {start, gameModal};
}
